import React, { useEffect, useRef } from 'react';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import dialogStyles from '../../common/dialogStyles';

interface UpdateDhcpReservationFormProps {
  reservationIp: string;
  reservationMac: string;
  reservationDescription: string;
  newDescription: string;
  setNewDescription: (val: string) => void;
  allowedInputCharacters: RegExp;
  isDescriptionValid: boolean;
  touched: { newDescription: boolean };
  markDescriptionTouched: () => void;
}

const UpdateDhcpReservationForm: React.FC<UpdateDhcpReservationFormProps> = ({
  reservationIp,
  reservationMac,
  reservationDescription,
  newDescription,
  setNewDescription,
  allowedInputCharacters,
  isDescriptionValid,
  touched,
  markDescriptionTouched,
}) => {
  useEffect(() => {
    setNewDescription(reservationDescription || '');
  }, []);

  const descriptionRef = useRef<HTMLInputElement | null>(null);

  const ShowValidationError =
    (!isDescriptionValid && touched.newDescription) || !isDescriptionValid;

  const getFieldHelperText = () => {
    if (ShowValidationError) {
      if (newDescription === reservationDescription) {
        return 'The new DHCP reservation description must be different from the current description.';
      }
      if (newDescription.trim().length === 0) {
        return 'DHCP reservation description cannot be empty.';
      }
      if (!allowedInputCharacters.test(newDescription)) {
        return 'Only alphanumeric characters, hyphens (-), and underscores (_) are allowed. No spaces or symbols.';
      }
    }

    return `${newDescription.length} / 20`;
  };

  return (
    <>
      <DialogContent sx={dialogStyles.dialogContentForm}>
        <Box sx={dialogStyles.reservationInfoStyles}>
          <Typography variant="subtitle1">MAC address: {reservationMac || ''}</Typography>
          <Typography variant="subtitle1">IP address: {reservationIp}</Typography>
        </Box>
        <Box sx={dialogStyles.reservationInfoStyles}>
          <Typography variant="subtitle1">current description: {reservationDescription}</Typography>
        </Box>
        <Box display="flex" flexDirection="column">
          <TextField
            label="New DHCP reservation description"
            value={newDescription.toLowerCase()}
            onChange={(e) => setNewDescription(e.target.value)}
            onBlur={markDescriptionTouched}
            required
            error={ShowValidationError}
            helperText={getFieldHelperText()}
            inputRef={descriptionRef}
            multiline
            maxRows={3}
            inputProps={{ maxLength: 20 }}
            sx={dialogStyles.dialogContentFormTextField}
            placeholder="Enter new description"
          />
        </Box>
      </DialogContent>
    </>
  );
};

export default UpdateDhcpReservationForm;
